module.exports = __webpack_public_path__ + "static/media/imageIcon.70249231.svg";